if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        autoplayEl: '.swiper-button-autoplay',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
        autoplayPlaying: 'swiper-autoplay-playing',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.cardStyle = this.dataset.cardStyle;
      this.itemSize = this.dataset.itemSize;
      this.columnsDesktop = this.dataset.columnsDesktop;
      this.columnsMobile = parseInt(this.dataset.columnsMobile) || 2;

      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 5000;

      this.sliderInstance = false;

      this.init(); // ✅ bỏ điều kiện mql, luôn khởi tạo slider
      this.handleAutoplayButton();
    }

    init() {
      // ❌ Bỏ điều kiện phá slider trên mobile
      // Luôn chạy slider trên mọi kích thước
      this.initSlider();
    }

    initSlider() {
      // console.log('columnsMobile:', this.dataset.columnsMobile);
      // console.log('columnsDesktop:', this.dataset.columnsDesktop);
      // console.log('itemSize:', this.itemSize);

      const autoplayConfig = this.autoplay
        ? {
            delay: this.autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false;

      const sliderOptions = {
        modules: [
          FoxTheme.Swiper.Navigation,
          FoxTheme.Swiper.Pagination,
          FoxTheme.Swiper.Mousewheel,
          FoxTheme.Swiper.Autoplay,
        ],
        slidesPerView: this.itemSize == 'fixed' ? this.columnsMobile : 'auto', 
        spaceBetween: 8,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        autoplay: autoplayConfig,
        pagination: false,
        loop: false,
        threshold: 2,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          0: { 
            spaceBetween: this.cardStyle == 'card' ? 8 : 10,
            slidesPerView:
              this.itemSize == 'fixed' ? this.columnsMobile : 'auto',
          },
          768: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 10,
            slidesPerView:
              this.itemSize == 'fixed'
                ? this.columnsDesktop > 4
                  ? 4
                  : this.columnsDesktop
                : 'auto',
          },
          1024: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? this.columnsDesktop > 6
                  ? this.columnsDesktop - 1
                  : this.columnsDesktop
                : 'auto',
          },
          1280: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? this.columnsDesktop
                : 'auto',
          },
        },
        on: {
          init: () => {
            this.updateAutoplayButton();
          },
        },
      };

      // Giữ nguyên logic khởi tạo swiper
      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(
              this.sliderInstance.slider.slides.indexOf(slide)
            );
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            const index = Number(e.target.dataset.index);
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }

    handleAutoplayButton() {
      const autoplayButton = this.section.querySelector(this.selectors.autoplayEl);
      if (!autoplayButton) return;

      autoplayButton.addEventListener('click', () => {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;
        const swiper = this.sliderInstance.slider;

        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
          this.section.classList.remove(this.classes.autoplayPlaying);
        } else {
          swiper.autoplay.start();
          this.section.classList.add(this.classes.autoplayPlaying);
        }

        this.updateAutoplayButton();
      });
    }

    updateAutoplayButton() {
      const autoplayButton = this.section.querySelector(this.selectors.autoplayEl);
      if (!autoplayButton || !this.sliderInstance) return;

      const swiper = this.sliderInstance.slider;
      const isPlaying = swiper.autoplay.running;

      if (isPlaying) {
        this.section.classList.add(this.classes.autoplayPlaying);
      } else {
        this.section.classList.remove(this.classes.autoplayPlaying);
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }

  customElements.define('collection-list', CollectionList);
}
